import UserAPI from '@/api/user'

const state = {
  layers: [],
  image: null
}

const getters = {
  getAll (state) {
    return state
  },
  getLayers (state) {
    return state.layers
  }
}
// actions
const actions = {
  async fetchAll (store) {
    const response = await UserAPI.get()
    store.commit('setLayers', response)

    return response
  }
}

const mutations = {
  setLayers (state, layers) {
    state.layers = layers
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
